import React, { useEffect, useState } from 'react';
import './AdminDashboard.css';

function AdminDashboard() {
    const [latestBookings, setLatestBookings] = useState([]);

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                const response = await fetch('http://localhost/hotel-bougainvilla/hotel-admin/backend/get_latest_bookings.php');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                if (data.success) {
                    setLatestBookings(data.bookings);
                } else {
                    console.error('Error fetching bookings:', data.error);
                }
            } catch (error) {
                console.error('Fetch error:', error);
            }
        };

        fetchBookings();
    }, []);

    return (
        <div className="admin-dashboard">
            <aside className="sidebar">
                <div className="logo">
                    <h2>HOTEL BOUGAINVILLA</h2>
                </div>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="/rooms">Rooms</a></li>
                    <li><a href="/booking">Bookings</a></li>
                    <li><a href="/">Website</a></li>
                    <li><a href="/admin/login">Admin Users</a></li>
                </ul>
            </aside>
            <main className="main-content">
                <header className="admin-header">
                    <h1>Dashboard</h1>
                    <div className="admin-header-right">
                        <a href="/" className="admin-open-site">Open The Main Site</a>
                        <span className="admin-user">Administrator</span>
                    </div>
                </header>
                <section className="admin-overview">
                    <div className="overview-item">
                        <h2>3</h2>
                        <p>Room Types</p>
                    </div>
                    <div className="overview-item">
                        <h2>11</h2>
                        <p>New Bookings</p>
                    </div>
                    <div className="overview-item">
                        <h2>0</h2>
                        <p>Confirmed Bookings</p>
                    </div>
                    <div className="overview-item">
                        <h2>0</h2>
                        <p>Special Offers</p>
                    </div>
                </section>
                <section className="latest-bookings">
                    <h2>Latest Bookings</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Room</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Total</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {latestBookings.map((booking, index) => (
                                <tr key={index}>
                                    <td>{booking.room_name}</td>
                                    <td>{new Date(booking.check_in).toLocaleDateString()}</td>
                                    <td>{new Date(booking.check_out).toLocaleDateString()}</td>
                                    <td>${booking.total_price.toFixed(2)}</td>
                                    <td>{booking.first_name}</td>
                                    <td>{booking.last_name}</td>
                                    <td>{booking.email}</td>
                                    <td>{booking.phone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </section>
            </main>
        </div>
    );
}

export default AdminDashboard;
